import { ItemModel } from '@leverege/ui-attributes'
import StationsCardDataViewer from './StationsCardDataViewer'
import EditStationCardSettingsAction from './actions/EditStationCardSettingsAction'

export default {
  install( molten ) {
    molten.addPlugin( 'Action', EditStationCardSettingsAction )
    molten.addPlugin( 'DataViewer', {
      type : 'stationsCard',
      name : 'Stations Card Data Viewer',
      icon : 'fa-solid fa-scissors',
      location : [ 'card', 'main' ],
      matches : {
        type : 'GroupDataViewer',
        objectType : 'station',
      },
      createSettings : () => {
        let mdl = ItemModel.create()
        mdl = ItemModel.addType( mdl, 'station' )

        return mdl
      },
      component : StationsCardDataViewer,
      getDefaultCardContentOptions : { height : '400px' },
    } )
  },
}
